export enum ContentType {
    EXCEL = 'application/vnd.ms-excel',
    PDF = 'application/pdf',
    CSV = 'text/csv',
    ZIP = 'application/zip'
}
